import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { getOktaAccessToken } from "../utils/oktaUtils";
/**
 * This file sets up the base request stub for all api requests
 * see CfaApi.ts for how to access okta-protected cfa apis
 * see PublicApi.ts for how to hit public apis
 */

// changing the baseURL is helpful when testing a api locally
const base = axios.create({
  // baseURL: "http://localhost:3000"
  headers: {
    "Content-Type": "application/json",
  },
});

const baseWithAccessToken = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

const onSuccess = (response: AxiosResponse) => {
  return response.data;
};

const onError = (error: AxiosError) => {
  if (error.response) {
    return Promise.reject({
      data: error.response.data,
      status: error.response.status,
      headers: error.response.headers,
    });
  }
  if (error.request) {
    // The request was made but no response was received
    return Promise.reject(error.request);
  }
  // Something happened in setting up the request that triggered an Error
  return Promise.reject(`Error ${error.message}`);
};

const request = (config: AxiosRequestConfig) => {
  return base(config).then(onSuccess).catch(onError);
};

const requestWithAccessToken = async (config: AxiosRequestConfig) => {
  setAuthTokenHeader(); //TODO: if implementing refresh logic in getOktaAccessToken, this will need to be async

  return baseWithAccessToken(config).then(onSuccess).catch(onError);
};

const setAuthTokenHeader = () => {
  baseWithAccessToken.defaults.headers.common.Authorization = `Bearer ${getOktaAccessToken()}`;
};

export { request, requestWithAccessToken, setAuthTokenHeader };
